// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_lzj","cls2":"dossier-cls2_w7C dossier-cls1_lzj"};